import React from "react";
import PropTypes from "prop-types";
import withIntl from "../../utils/withIntl";
import { NavLink, withRouter } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SyncButton from "./SyncButton";
import { useTheme } from "@material-ui/core/styles";
import Link from "../../utils/routes/Link";
import AuthorizationWrapper from "../AuthorizationWrapper";

function NavigationMenuItem(props) {
  const theme = useTheme();

  const handleOnClickLink = (e) => {
    props.onClick(e);
    if (props.link.match(props.location.pathname)) {
      e.preventDefault();
    }
  };

  const handleMouseOver = (e) => {
    props.onMouseOver(e);
  };

  const item = (
    <NavLink to={props.link.getLink()} style={{ textDecoration: "none", color: "black" }}>
      <ListItem button onClick={handleOnClickLink}>
        <ListItemIcon
          onMouseOver={handleMouseOver}
          style={{ color: props.link.match(props.location.pathname) ? theme.palette.primary.main : null }}
        >
          {props.link.icon}
        </ListItemIcon>
        {props.link.name?.length > 0 && <ListItemText primary={props.intl.formatMessage({ id: props.link.name })} />}
        {props.link.name === "articles" && <SyncButton />}
      </ListItem>
    </NavLink>
  );

  if (props.link.authenticationName) {
    return <AuthorizationWrapper permission={props.link.authenticationName} child={item} />;
  } else {
    return item;
  }
}

NavigationMenuItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  link: PropTypes.instanceOf(Link),
};

export default withRouter(withIntl(NavigationMenuItem));
